import React from 'react'

const BranchSvg = ({ fillColor, width, height, size }) => {
  const currentSize = size || width || height || "24px";
  return (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={currentSize} 
        height={currentSize} 
        viewBox="0 0 24 24" 
        fill="none"
        stroke={fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="3" y="10" width="18" height="12" rx="2" />
        <path d="M3 10L12 3l9 7" />
        <line x1="12" y1="22" x2="12" y2="16" />
    </svg>
  )
}

export default BranchSvg